module.exports = __webpack_public_path__ + "static/media/live27_02_2018.419a47f5.jpg";